module.exports = __webpack_public_path__ + "static/media/fan2_lamp0.af3bd1ab.gif";